import { combineReducers } from 'redux';
import app from './app';
import menu from './menu';

export default combineReducers({ app, menu });
